<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <dev-param-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></dev-param-form>
  </j-modal>
</template>

<script>
import DevParamForm from './DevParamForm'
export default {
  name: 'DevParamModal',
  components: {
    DevParamForm
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false
    }
  },
  props: {
    devId: {
      type: String,
      default: ''
    },
    deviceData: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    add() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add(this.deviceData)
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.$refs.realForm.submitForm()
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
